var map = {
	"./bubblePop.dragEqual.props.json": 808,
	"./com.playpower.activityTypes.allGames.props.json": 809,
	"./com.playpower.activityTypes.flashFlow.props.json": 810,
	"./com.playpower.activityTypes.flashMath.props.json": 811,
	"./com.playpower.activityTypes.mathPlanet.props.json": 812,
	"./com.playpower.activityTypes.mathPlanetForLink.props.json": 813,
	"./com.playpower.activityTypes.mathfluencyGamesActivity.props.json": 814,
	"./com.playpower.activityTypes.mathfluencyGamesActivity1.props.json": 815,
	"./com.playpower.activityTypes.mathfluencyMathFlowMCQ.props.json": 816,
	"./com.playpower.activityTypes.mathfluencyMathFlowRW.props.json": 817,
	"./com.playpower.activityTypes.mathfluencyMathFlowTextInp.props.json": 818,
	"./com.playpower.activityTypes.neurometricGames.props.json": 819,
	"./com.playpower.activityTypes.neurometricGamesActivity.props.json": 820,
	"./com.playpower.activityTypes.previewPlayer.props.json": 821,
	"./com.playpower.activityTypes.zensus.props.json": 822,
	"./com.playpower.itemTypes.adaptiveCAT.props.json": 823,
	"./com.playpower.itemTypes.bsnl.props.json": 824,
	"./com.playpower.itemTypes.bsnl_Multiplayer.props.json": 825,
	"./com.playpower.itemTypes.bubblePop.props.json": 826,
	"./com.playpower.itemTypes.bubblePop1.props.json": 827,
	"./com.playpower.itemTypes.bubblePop2.props.json": 828,
	"./com.playpower.itemTypes.bubblePop3.props.json": 829,
	"./com.playpower.itemTypes.bubblePop4.props.json": 830,
	"./com.playpower.itemTypes.bubblePop5.props.json": 831,
	"./com.playpower.itemTypes.bubblePopLinePop.props.json": 832,
	"./com.playpower.itemTypes.bubblePopNormalFlow.props.json": 833,
	"./com.playpower.itemTypes.bubblePopNormalFlowDemo.props.json": 834,
	"./com.playpower.itemTypes.clippingNodeEg.props.json": 835,
	"./com.playpower.itemTypes.clockGame.analog.props.json": 836,
	"./com.playpower.itemTypes.clockGame.analogToDigital.props.json": 837,
	"./com.playpower.itemTypes.clockGame.digitalToAnalog.props.json": 838,
	"./com.playpower.itemTypes.clockGame.props.json": 839,
	"./com.playpower.itemTypes.clockGame.stopTheClock.props.json": 840,
	"./com.playpower.itemTypes.clockGameV2.analog.props.json": 841,
	"./com.playpower.itemTypes.clockGameV2.analogToDigital.props.json": 842,
	"./com.playpower.itemTypes.clockGameV2.digitalToAnalog.props.json": 843,
	"./com.playpower.itemTypes.clockGameV2.props.json": 844,
	"./com.playpower.itemTypes.clockGameV2.stopTheClock.props.json": 845,
	"./com.playpower.itemTypes.copyKat.props.json": 846,
	"./com.playpower.itemTypes.copyKatV2.props.json": 847,
	"./com.playpower.itemTypes.corsiBlockTest.props.json": 848,
	"./com.playpower.itemTypes.emaMcq.props.json": 849,
	"./com.playpower.itemTypes.emaMcqV2.props.json": 850,
	"./com.playpower.itemTypes.emotionRecognition.props.json": 851,
	"./com.playpower.itemTypes.flanker.props.json": 852,
	"./com.playpower.itemTypes.flashCard.props.json": 853,
	"./com.playpower.itemTypes.flashMath.props.json": 854,
	"./com.playpower.itemTypes.handSwype.props.json": 855,
	"./com.playpower.itemTypes.jellyBean.props.json": 856,
	"./com.playpower.itemTypes.jellyBeanCounting.props.json": 857,
	"./com.playpower.itemTypes.jellyBeanDragAndDrop.props.json": 858,
	"./com.playpower.itemTypes.jellyBeanTapTheBigger.props.json": 859,
	"./com.playpower.itemTypes.jellyBeanV2BoxWithMoreJellies.props.json": 860,
	"./com.playpower.itemTypes.jellyBeanV2Counting.props.json": 861,
	"./com.playpower.itemTypes.jellyBeanV2DragAndDrop.props.json": 862,
	"./com.playpower.itemTypes.jellyBeanV2KeyboardEquation.props.json": 863,
	"./com.playpower.itemTypes.jellyBeanV2OddEven.props.json": 864,
	"./com.playpower.itemTypes.matchingPair.props.json": 865,
	"./com.playpower.itemTypes.matchingTiles.props.json": 866,
	"./com.playpower.itemTypes.mathFact.props.json": 867,
	"./com.playpower.itemTypes.mathFlow.props.json": 868,
	"./com.playpower.itemTypes.memoryGame.props.json": 869,
	"./com.playpower.itemTypes.memoryList.props.json": 870,
	"./com.playpower.itemTypes.memoryMatrix.props.json": 871,
	"./com.playpower.itemTypes.memoryMatrixV2.props.json": 872,
	"./com.playpower.itemTypes.numberJumble.props.json": 873,
	"./com.playpower.itemTypes.oddOneOut.props.json": 874,
	"./com.playpower.itemTypes.oddOneOutV2.props.json": 875,
	"./com.playpower.itemTypes.partyTimeAll.props.json": 876,
	"./com.playpower.itemTypes.partyTimeDistributePieces.props.json": 877,
	"./com.playpower.itemTypes.partyTimeDragWhole.props.json": 878,
	"./com.playpower.itemTypes.partyTimeKnifeCut.props.json": 879,
	"./com.playpower.itemTypes.partyTimeMcq.props.json": 880,
	"./com.playpower.itemTypes.partyTimeSliceOMatic.props.json": 881,
	"./com.playpower.itemTypes.partyTimeSlideMany.props.json": 882,
	"./com.playpower.itemTypes.partyTimeSlideOne.props.json": 883,
	"./com.playpower.itemTypes.pearsonImageMcq.props.json": 884,
	"./com.playpower.itemTypes.pearsonQuickCheck.props.json": 885,
	"./com.playpower.itemTypes.placeValue.change.props.json": 886,
	"./com.playpower.itemTypes.placeValue.click.props.json": 887,
	"./com.playpower.itemTypes.placeValue.drag.props.json": 888,
	"./com.playpower.itemTypes.placeValue.dragToMake.props.json": 889,
	"./com.playpower.itemTypes.placeValue.highest.props.json": 890,
	"./com.playpower.itemTypes.placeValue.make.props.json": 891,
	"./com.playpower.itemTypes.placeValue.match.props.json": 892,
	"./com.playpower.itemTypes.placeValue.mcq.props.json": 893,
	"./com.playpower.itemTypes.placeValue.props.json": 894,
	"./com.playpower.itemTypes.placeValueV2.change.props.json": 895,
	"./com.playpower.itemTypes.placeValueV2.click.props.json": 896,
	"./com.playpower.itemTypes.placeValueV2.drag.props.json": 897,
	"./com.playpower.itemTypes.placeValueV2.dragToMake.props.json": 898,
	"./com.playpower.itemTypes.placeValueV2.highest.props.json": 899,
	"./com.playpower.itemTypes.placeValueV2.make.props.json": 900,
	"./com.playpower.itemTypes.placeValueV2.match.props.json": 901,
	"./com.playpower.itemTypes.placeValueV2.mcq.props.json": 902,
	"./com.playpower.itemTypes.placeValueV2.props.json": 903,
	"./com.playpower.itemTypes.quickTap.props.json": 904,
	"./com.playpower.itemTypes.quickTapV2.props.json": 905,
	"./com.playpower.itemTypes.scaleTask.props.json": 906,
	"./com.playpower.itemTypes.scaleTaskNew.props.json": 907,
	"./com.playpower.itemTypes.scaleTaskOld.props.json": 908,
	"./com.playpower.itemTypes.specialDelivery.props.json": 909,
	"./com.playpower.itemTypes.stroop.props.json": 910,
	"./com.playpower.itemTypes.stroopV2.props.json": 911,
	"./com.playpower.itemTypes.stroopV3.props.json": 912,
	"./com.playpower.itemTypes.thinkBigger.props.json": 913,
	"./com.playpower.itemTypes.trainGame.props.json": 914,
	"./com.playpower.itemTypes.zensus.props.json": 915,
	"./com.playpower.questionTypes..wordList.tutorial.props.json": 916,
	"./com.playpower.questionTypes.ScoreCard.main.props.json": 917,
	"./com.playpower.questionTypes.bsnl.click.props.json": 918,
	"./com.playpower.questionTypes.bsnl.keyboard.props.json": 919,
	"./com.playpower.questionTypes.bsnl.mcq.props.json": 920,
	"./com.playpower.questionTypes.bsnl.scorecard.props.json": 921,
	"./com.playpower.questionTypes.bubblePop.dragEqual.props.json": 922,
	"./com.playpower.questionTypes.bubblePop.fillInTheBlanks.props.json": 923,
	"./com.playpower.questionTypes.bubblePop.inOrder.props.json": 924,
	"./com.playpower.questionTypes.bubblePop.linePop.props.json": 925,
	"./com.playpower.questionTypes.bubblePop.mcq.props.json": 926,
	"./com.playpower.questionTypes.bubblePop.skipCount.props.json": 927,
	"./com.playpower.questionTypes.clippingNodeEg.props.json": 928,
	"./com.playpower.questionTypes.clockGame.analog.props.json": 929,
	"./com.playpower.questionTypes.copyKat.main.props.json": 930,
	"./com.playpower.questionTypes.customBookReader.main.props.json": 931,
	"./com.playpower.questionTypes.emaMcq.Checkbox.props.json": 932,
	"./com.playpower.questionTypes.emaMcq.Radio.props.json": 933,
	"./com.playpower.questionTypes.emaMcq.Rating.props.json": 934,
	"./com.playpower.questionTypes.emaMcq.emaMcqMain.props.json": 935,
	"./com.playpower.questionTypes.emaMcq.props.json": 936,
	"./com.playpower.questionTypes.emaMcq.slider.props.json": 937,
	"./com.playpower.questionTypes.etsScorecard.main.props.json": 938,
	"./com.playpower.questionTypes.flanker.main.props.json": 939,
	"./com.playpower.questionTypes.flashCard.main.props.json": 940,
	"./com.playpower.questionTypes.flashMathCelebration.main.props.json": 941,
	"./com.playpower.questionTypes.gridViewTest.main.props.json": 942,
	"./com.playpower.questionTypes.jellyBean.boxWithMoreJellies.props.json": 943,
	"./com.playpower.questionTypes.jellyBean.counting.props.json": 944,
	"./com.playpower.questionTypes.jellyBean.drag.props.json": 945,
	"./com.playpower.questionTypes.jellyBean.dragAndDrop.props.json": 946,
	"./com.playpower.questionTypes.jellyBean.dragNumber.props.json": 947,
	"./com.playpower.questionTypes.jellyBean.matchEquationWithBox.props.json": 948,
	"./com.playpower.questionTypes.jellyBean.tapTheBigger.props.json": 949,
	"./com.playpower.questionTypes.jellyBeanV2.boxWithMoreJellies.props.json": 950,
	"./com.playpower.questionTypes.jellyBeanV2.counting.props.json": 951,
	"./com.playpower.questionTypes.jellyBeanV2.dragAndDrop.props.json": 952,
	"./com.playpower.questionTypes.jellyBeanV2.keyboardEquation.props.json": 953,
	"./com.playpower.questionTypes.jellyBeanV2.oddEven.props.json": 954,
	"./com.playpower.questionTypes.matchingTiles.main.props.json": 955,
	"./com.playpower.questionTypes.mathFact.main.props.json": 956,
	"./com.playpower.questionTypes.mathFlow.main.props.json": 957,
	"./com.playpower.questionTypes.mathFlow.pearsonMcq.props.json": 958,
	"./com.playpower.questionTypes.mathFlow.pearsonScorecard.props.json": 959,
	"./com.playpower.questionTypes.mathFlow.rightWrong.props.json": 960,
	"./com.playpower.questionTypes.mathFlow.textInput.props.json": 961,
	"./com.playpower.questionTypes.mathfluencyScorecard.main.props.json": 962,
	"./com.playpower.questionTypes.memoryMatrix.main.props.json": 963,
	"./com.playpower.questionTypes.memoryMatrixV2.main.props.json": 964,
	"./com.playpower.questionTypes.oddOneOut.main.props.json": 965,
	"./com.playpower.questionTypes.oddOneOut.scorecard.props.json": 966,
	"./com.playpower.questionTypes.partyTime.drag.props.json": 967,
	"./com.playpower.questionTypes.partyTime.mcq.props.json": 968,
	"./com.playpower.questionTypes.partyTime.sliceOMatic.props.json": 969,
	"./com.playpower.questionTypes.placeValue.main.props.json": 970,
	"./com.playpower.questionTypes.quickTapV2.main.props.json": 971,
	"./com.playpower.questionTypes.reactionTime.props.json": 972,
	"./com.playpower.questionTypes.scaleTask.balanceWeight.props.json": 973,
	"./com.playpower.questionTypes.scaleTaskNew.balanceWeight.props.json": 974,
	"./com.playpower.questionTypes.scaleTaskOld.balanceWeight.props.json": 975,
	"./com.playpower.questionTypes.simonGameOld.simonMain.props.json": 976,
	"./com.playpower.questionTypes.specialDelivery.main.props.json": 977,
	"./com.playpower.questionTypes.trainGame.main.props.json": 978,
	"./com.playpower.questionTypes.wordList.tutorial.props.json": 979,
	"./com.playpower.questionTypes.zensus.radio.props.json": 980,
	"./demo.props.json": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 807;